import { authApi } from "../../../common/redux/services/auth";
import { mainServiceURL } from "../../../common/redux/services/defines";

interface UserResponse {
  data: any;
}

interface MenuResponse {
  data: any[];
}

export const authorisationApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCurrentUser: builder.query<UserResponse, void>({
      query: () => mainServiceURL + `/users/current`,
      providesTags: ["Authorisation"],
    }),
    fetchMenu: builder.query<MenuResponse, void>({
      query: () => mainServiceURL + `/settings/menu`,
      providesTags: ["Authorisation"],
    }),
  }),
});

export const {
  useFetchCurrentUserQuery,
  useLazyFetchCurrentUserQuery,
  useFetchMenuQuery,
  useLazyFetchMenuQuery,
} = authorisationApi;
